module.exports = __webpack_public_path__ + "static/media/video.7ee98eda.mp4";